import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    roomFailedPayment: [],
    error: null
};

export const roomFailedPaymentSlice = createSlice({
    name: "roomFailedPayment",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        roomFailedPaymentFetched: (state, action) => {
            state.loading = false;
            state.error = null;
            state.roomFailedPayment = action.payload.roomFailedPayment;
        },
    }
});
